import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import { generateUniqueID } from "utils-lib/requests"

export const getMIAWChatAgentsAvailability = () => () => {
  const api = `MIAW_CHAT`
  const template = URITemplate(urls.url[api])
  const url = template.expand()
  const config = {
    url,
    method: `get`,
    headers: {
      "Content-Type": `application/json`,
      ClientId: urls.cloudCraze.headers.ClientId,
      "Request-Tracking-Id": generateUniqueID(),
    },
  }

  return axios(config)
    .then((response) => response.data.is_agent_available)
    .catch(() => null)
}
